import Form_10 from './Form_10-redux';

export default Form_10;
